import { render, staticRenderFns } from "./qualificationStatus.vue?vue&type=template&id=53335b95&scoped=true&"
import script from "./qualificationStatus.vue?vue&type=script&lang=js&"
export * from "./qualificationStatus.vue?vue&type=script&lang=js&"
import style0 from "./qualificationStatus.vue?vue&type=style&index=0&id=53335b95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53335b95",
  null
  
)

export default component.exports